// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Mail = function Mail(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.966 3.044a.859.859 0 00-.6-.241H1.634a.859.859 0 00-.572.217l6.975 6z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8.038 10.3L.791 4.067v8.392a.826.826 0 00.843.807h12.732a.826.826 0 00.843-.807V4.115z"
    }))
  );
};

export default Mail;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Mail.js
// module id = 1029
// module chunks = 0